import {
  createPluginFactory,
  onKeyDownToggleElement,
  ELEMENT_TODO_LI,
} from '@udecode/plate';
import { withTodoList } from './withTodoList';

export const createTodoListPlugin = createPluginFactory({
  key: ELEMENT_TODO_LI,
  isElement: true,
  withOverrides: withTodoList,
  handlers: {
    onKeyDown: onKeyDownToggleElement,
  },
  options: {
    hotkey: ['mod+opt+4', 'mod+shift+4'],
  },
});